import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { STAGING_MODE_OPTIONS } from '../../types/apiKeyConstants';

const EditStagingModeDialog = ({ open, onClose, apiKey, onConfirm }) => {
  const [stagingValue, setStagingValue] = useState('NONE');

  useEffect(() => {
    if (apiKey) {
      setStagingValue(apiKey.stagingMode || 'NONE');
    }
  }, [apiKey]);

  const handleConfirm = async () => {
    await onConfirm(apiKey.id, stagingValue);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>Edit Staging Mode</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Change the staging mode for key <b>{apiKey?.keyPrefix}…</b>
        </DialogContentText>
        <FormControl fullWidth margin='dense'>
          <InputLabel>Staging Mode</InputLabel>
          <Select
            value={stagingValue}
            label='Staging Mode'
            onChange={(e) => setStagingValue(e.target.value)}
          >
            {STAGING_MODE_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant='contained' onClick={handleConfirm}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditStagingModeDialog;
